import ModuleSetupPage from '../../components/ModuleSetupPage';
import MaintenanceSetupPage from './MaintenanceSetupPage';

export default function MaintenanceModuleSetupPage() {
  return (
    <ModuleSetupPage
      moduleKey="maintenance"
      moduleLabel="Truck Maintenance"
      configComponent={<MaintenanceSetupPage embedded />}
    />
  );
}
